import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import ProductHelper from 'src/app/helpers/product-helper';
import Board from 'src/app/model/product/board/board';
import Product from 'src/app/model/product/product';
import { SubProject } from 'src/app/model/project/sub-project';
import { ProjectsTableComponent } from '../projects-table/projects-table.component';

@Component({
  selector: 'new-projects',
  templateUrl: '../projects-table/projects-table.component.html',
  styleUrls: ['../projects-table/projects-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewProjectsComponent extends ProjectsTableComponent {
  ngOnInit() {
    super.ngOnInit();
    this.projects = [];
    this.displayedColumns = [
      'project_id',
      'requestor',
      'currentCreatedAt',
      'currentRequestDate',
      'currentConfirmedPlacementDate',
      'company',
      'projectPlacement.address',
      'productType',
      'productSize',
      'boardTypeAndPlacement',
      'displayStatus',
      'star'
    ];
  }

  protected getLocalStorageKey(): string {
    return 'NewProjectsComponent';
  }

  protected getStatusFilter(): string {
    return 'status/vv,Afhaling,Aanpassing,Concept,Nieuw';
  }

  public getPageTitle(): string {
    return 'Nieuwe';
  }

  // Override
  protected preProcessProjects(subProjects: SubProject[]): void {
    super.preProcessProjects(subProjects);

    subProjects.forEach(sp => {
      if (
        sp.project != null &&
        CollectionHelper.isPopulated(sp.project.products)
      ) {
        sp.project.products.forEach(p => this.preprocessProduct(p));
      }
    });
  }

  private preprocessProduct(product: Product) {
    if (ProductHelper.isBoard(product)) {
      ProductHelper.calculateTableBoardDisplay(<Board>product);
    }
  }

  // Override
  public getDefaultSort(): string {
    return 'currentRequestDate';
  }
}
